export const isPermittedRoute = (route, userData) => {
  console.log(userData);
  if (route?.permission) return !!userData?.[route?.permission];

  return true;
};